import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Top from "../../images/location/atlanta/top-mobile.png";
import {Link} from 'gatsby';

function Topmobile(props) {
    return (
        <div className="top-mobile p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <h2>A Top Mobile App Development Company in Atlanta</h2>
                        <p>TekRevol is a reliable digital solution provider in the global market especially when it comes to mobile app development in Atlanta. We've been on the pathway to growth & sustainability since our inception.</p>
                        <p>There are different business sectors that we serve for their advancement to compete in the digital market. We understand our client’s goals and business requirements. After that, our professional Atlanta app developers suggest the right solutions based on a result-oriented approach.</p>
                        <p>We offer mobile apps for both Android and iOS considering the preference of our clients. Further, you can have hybrid or cross-platform applications to target the maximum audience. Using a customized approach, we enable businesses to magnify their online presence.</p>
                        <p>We encourage the deployment of new technologies in our development process to provide a unique digital solution to our clients. Our priority is to explore new stacks to continuously improve mobile app development in Atlanta.</p>
                        <p>So, connect with us to discuss your idea and we’ll ensure to provide you with reliable solutions. </p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="top-mob-img">
                            <LazyLoadImage
                                src={Top}
                                effect="blur" alt="Tab_01" className="img-fluid catalyze-img"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Topmobile;